const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaroPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.84,5.09l-2.85,2.86.75.75,2.85-2.86-.75-.75Z",
    style: {
      fill: "#eb3b2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74,4.5h-1.06v3.06h1.06v-3.06Z",
    style: {
      fill: "#eb3b2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07,8.52c-.67,0-1.25.24-1.73.73-.49.49-.73,1.08-.73,1.76s.24,1.28.73,1.75c.48.49,1.06.74,1.73.74s1.26-.25,1.75-.74c.48-.48.72-1.07.72-1.75s-.24-1.28-.72-1.76c-.49-.49-1.08-.73-1.75-.73ZM7.99,11.93c-.25.26-.56.38-.92.38s-.66-.13-.91-.38c-.25-.26-.39-.57-.39-.92s.14-.68.39-.93c.25-.26.56-.39.91-.38.36-.01.67.11.93.38.24.25.37.56.38.93-.02.35-.14.66-.39.92Z",
    style: {
      fill: "#eb3b2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.39,10.2v-.31h-3.13v1.06h3.13v-.74Z",
    style: {
      fill: "#eb3b2f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaroPay);
export default __webpack_public_path__ + "static/media/claro-pay.9438b8b619eaaca7581b9388c695aa4f.svg";
export { ForwardRef as ReactComponent };